import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { addClass } from '../../utils/css.js';
import '../../constants.js';
import { RadioGroupContextProvider } from './RadioGroupContext.js';

class RadioGroup extends React.PureComponent {
  render() {
    const { htmlId, dataTa, className, children, onChange, value, ...rest } = this.props;
    const id = Id.create(htmlId, ["radio group"]);
    return /* @__PURE__ */ React.createElement("div", {
      id: id.toString(),
      role: "radiogroup",
      "data-ta": dataTa,
      className: addClass("vai-radio-group", className),
      ...rest
    }, /* @__PURE__ */ React.createElement(RadioGroupContextProvider, {
      value: { onChange, value }
    }, children));
  }
}
RadioGroup.metaProperties = [];

export { RadioGroup };
